"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _RequestTool = require("./RequestTool.styled");
var _hooks = require("../../../hooks");
var _l10n = require("../../../l10n");
const Error = () => {
  const getMessageFromKey = (0, _l10n.getMessages)((0, _hooks.useLocale)());
  return /*#__PURE__*/_react.default.createElement(_RequestTool.RequestSentContainer, null, /*#__PURE__*/_react.default.createElement(_RequestTool.ResponseContainer, null, /*#__PURE__*/_react.default.createElement(_RequestTool.ErrorIcon, {
    icon: "warning-triangle",
    size: "4x"
  }), /*#__PURE__*/_react.default.createElement(_RequestTool.ResponseTitle, null, getMessageFromKey('RequestTool.receiveData.errorTittle')), /*#__PURE__*/_react.default.createElement(_RequestTool.ResponseTitle, null, getMessageFromKey('RequestTool.receiveData.errorSubTitle'))));
};
var _default = exports.default = Error;